// @flow

export default function nameFromEmail(email: string) {
  const firstPartEmail = email.split('@')[0];
  let name = '';
  if (firstPartEmail.includes('.')) {
    name = firstPartEmail.replace('.', ' ');
  } else if (firstPartEmail.includes('_')) {
    name = firstPartEmail.replace('_', ' ');
  } else {
    name = firstPartEmail;
  }
  // Remove all numbers from name and capitalize
  name = name.replace(/[0-9]/g, '');
  name = name.replace(
    /\w\S*/g,
    (tStr) => tStr.charAt(0).toUpperCase() + tStr.substr(1).toLowerCase(),
  );
  return name;
}
